module.exports = __webpack_public_path__ + "static/media/copy.b2f7b08e.png";